export const iconFontAwesomeGendersMarsStroke = (
	<i className="fa-solid fa-mars-stroke"></i>
);
